import { fromEvent } from 'rxjs';

export const onDocumentVisibilityChange = fromEvent(document, 'visibilitychange');
export const onDocumentWebKitVisibilityChange = fromEvent(document, 'webkitvisibilitychange');
